import { Award } from "lucide-react";
import PhotoSlider from "@/components/site/PhotoSlider";

const slides = [
  { id: "fel-1", label: "Felicitation Ceremony — Photo 1" },
  { id: "fel-2", label: "Felicitation Ceremony — Photo 2" },
  { id: "fel-3", label: "Felicitation Ceremony — Photo 3" },
  { id: "fel-4", label: "Felicitation Ceremony — Photo 4" },
];

export default function Felicitation() {
  return (
    <section
      id="felicitation"
      data-testid="felicitation-section"
      className="relative overflow-hidden bg-white py-14 md:py-24"
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -left-32 top-20 h-72 w-72 rounded-full bg-red-200/30 blur-3xl"
      />
      <div className="container mx-auto px-4 md:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <div className="inline-flex items-center gap-2 rounded-full bg-red-50 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.2em] text-red-700">
            <Award className="h-3.5 w-3.5" />
            Felicitation Program
          </div>
          <h2 className="mt-4 font-display text-3xl font-extrabold leading-tight text-slate-900 sm:text-4xl lg:text-5xl">
            Celebrating every win,{" "}
            <span className="text-red-600">big or small.</span>
          </h2>
          <p className="mt-3 text-[15px] leading-relaxed text-slate-600 md:text-base">
            Each year we honour our toppers, consistent performers and
            star-improvers in front of their parents and peers.
          </p>
        </div>

        <div className="mt-10 md:mt-14">
          <PhotoSlider
            testid="felicitation-slider"
            slides={slides}
            accentIcon={Award}
          />
        </div>
      </div>
    </section>
  );
}
